export enum VideoAdState {
  Started = 'started',
  Finished = 'finished',
}
